export const taxonsSelector = (state) => state.taxons;

export default taxonsSelector;
